var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteicon = function SvgDeleteicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.4 3.45v-.7c0-.2-.16-.35-.35-.35H9.9v-.7a.7.7 0 0 0-.7-.7H6.4a.7.7 0 0 0-.7.7v.7H2.55c-.2 0-.35.16-.35.35v.7c0 .2.16.35.35.35h10.5c.2 0 .35-.16.35-.35ZM4.8 12.2h6l.5-7h1.4l-.6 8.5a1.4 1.4 0 0 1-1.4 1.3H4.9a1.4 1.4 0 0 1-1.4-1.3l-.6-8.5h1.4l.5 7Zm2.3-7v5.6H5.7V5.2h1.4Zm2.8 0H8.5v5.6h1.4V5.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgDeleteicon;